<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Dear A. Jones,<br /><br />

    As requested by you, I have already started searching for suitable companies
    to build our transmission towe$ and also asked directly under what
    conditions they would execute our project. Here is what I found:<br /><br />

    <u><b>Thaheem Construction Company:</b></u
    ><br />
    100 New Gardens, Portland, Oregon.<br />
    Telephone: +1 42-35846056<br />
    FAX: +1 42-35831048<br />
    E-mail: admnlhr@thaheemgroup.co<br />
    Cost of our project: approximately $50,00,00,000<br />
    Estimated completion date: April 2023<br /><br />

    <u><b>MY Construction:</b></u
    ><br />
    28 Van Ness Park, Portland, Oregon.<br />
    Telephone: +1 78-64578913<br />
    FAX: +1 78-64578874<br />
    E-mail: info@myconstruction.co<br />
    Cost of our project: approximately $44,00,00,000<br />
    Estimated completion date: September 2023<br /><br />

    <u><b>Pinnacle Construction:</b></u
    ><br />
    250 Main Blvd, Section B, Portland, Oregon.<br />
    Telephone: +1 42 32030247<br />
    FAX: +1 44 3203874<br />
    E-mail: pinnacledha@gmail.com<br />
    Cost of our project: approximately $40,00,00,000<br />
    Estimated completion date: July 2023<br /><br />

    <u><b>Hallmark Construction Services:</b></u
    ><br />
    15A, Block G-1, Canal Bank Road, Portland, Oregon.<br />
    Telephone: +1-423-5291006-9<br />
    FAX: +1-423-5291195<br />
    E-mail: hcs@hcs.com<br />
    Cost of our project: approximately $39,00,00,000<br />
    Estimated completion date: December 2023
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
